// Catégories principales de KUDHI - Généré automatiquement depuis la base de données

export const CATEGORIES = [
  'Toutes les catégories',

  'Accessoires ordinateur',
  'Accessoires téléphones',
  'Agriculture',
  'Art & Artisanat',
  'Auto - Moto',
  'Autres',
  'Beauté & Cosmétique',
  'Bijoux',
  'Chaussures',
  'Collections & Antiquités',
  'Décorations',
  'Électroménager',
  'Enceintes & Casques',
  'Films & Séries',
  'Formations',
  'Immobilier',
  'Industrie',
  'Informatique',
  'Jeux vidéo & Consoles',
  'Jouets & Enfants',
  'Livres',
  'Loisirs',
  'Modes',
  'Montres',
  'Musique & Instruments',
  'Objets connectés',
  'Ordinateurs',
  'Restauration',
  'Sacs',
  'Services',
  'Smartphones',
  'Sports & Fitness',
  'TV',
  'Vêtements',
]
